/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./audience.vue?vue&type=template&id=19b56502&scoped=true&"
import script from "./audience.vue?vue&type=script&lang=js&"
export * from "./audience.vue?vue&type=script&lang=js&"
import style0 from "./audience.vue?vue&type=style&index=0&id=19b56502&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b56502",
  null
  
)

export default component.exports